<div class="fixed-bg"></div>
<div class="result-page">
  <div class="container">
    <div class="icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    </div>

    <h1>Acconto Pagato!</h1>

    <p class="main-message">
      L'acconto per l'iscrizione a
      <strong>Ohel Camp 2026</strong>
      e stato pagato con successo.
    </p>

    <p class="sub-message">
      Riceverai una email di conferma con tutti i dettagli all'indirizzo fornito
      durante l'iscrizione. Il saldo restante sara da pagare in sede.
    </p>

    <a routerLink="/ohelcamp" class="action-btn">Nuova Iscrizione</a>
  </div>
</div>
